import { Reveal, MaskLine } from "./Reveal";
import { scrollToSection } from "@/lib/scroll";

export const FinalCTA = () => (
  <section data-testid="final-cta-section" className="bg-cream text-obsidian py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <div className="flex items-center gap-4 mb-12">
        <span className="font-mono text-xs font-bold tracking-[0.25em]">{"//"} 16</span>
        <span className="h-px flex-1 bg-obsidian/20" />
        <span className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-obsidian/60">Final Call</span>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
        <div className="lg:col-span-8">
          <h2 className="font-display font-extrabold uppercase tracking-tighter leading-[0.85] text-[clamp(3rem,9vw,8rem)]">
            <MaskLine>Ideas move</MaskLine>
            <MaskLine delay={0.12}>differently <span className="align-top text-[0.5em]">{"//"}</span></MaskLine>
            <MaskLine delay={0.24}>here.</MaskLine>
          </h2>
          <Reveal delay={0.3}>
            <p className="mt-8 font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-obsidian/70" data-testid="cta-urgency">
              Next cohort starts soon — maximum 15 seats per track
            </p>
          </Reveal>
        </div>
        <Reveal delay={0.2} className="lg:col-span-4 lg:justify-self-end w-full lg:w-auto">
          <button
            data-testid="final-cta-apply-btn"
            onClick={() => scrollToSection("apply")}
            className="w-full lg:w-auto bg-obsidian text-acid font-mono text-sm font-bold uppercase tracking-[0.2em] px-10 py-6 hover:scale-[1.03] active:scale-[0.98] transition-transform duration-300"
          >
            Claim Your Seat
          </button>
        </Reveal>
      </div>
    </div>
  </section>
);
